import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchUserOtherTeams, FetchUserOtherTeamsFailure, FetchUserOtherTeamsSuccess } from '../actions';

@Injectable()
export class UserOtherTeamsResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const teamId = route.params['teamId'];
        const userId = route.params['userId'];

        this._store.dispatch(new FetchUserOtherTeams(teamId, userId));

        return this._actionHelper.race(FetchUserOtherTeamsSuccess, FetchUserOtherTeamsFailure);
    }
}
